import { render } from "./ArchivoPla.vue?vue&type=template&id=4d3fea42&scoped=true"
import script from "./ArchivoPla.vue?vue&type=script&lang=js"
export * from "./ArchivoPla.vue?vue&type=script&lang=js"

import "./ArchivoPla.vue?vue&type=style&index=0&id=4d3fea42&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3fea42"]])

export default __exports__